
const getList = state => state.list
const getAvailableAppointments = state => state.availableAppointments

export default {
  getList,
  getAvailableAppointments
}



// WEBPACK FOOTER //
// ./src/store/modules/exam/getters.js